export type DefinitionCoverageChecklistItem = {
  key: string;
  label: string;
  done: boolean;
  hint?: string;
};

export function buildDefinitionCoverageChecklistItems(
  counts: { goals: number; features: number; inScope: number },
  options: { hintSuffix?: string } = {},
): DefinitionCoverageChecklistItem[] {
  const suffix = options.hintSuffix ?? '.';
  const { goals, features, inScope } = counts;

  return [
    {
      key: 'goals',
      label: 'Goals (≥ 1)',
      done: goals >= 1,
      hint: goals >= 1 ? undefined : `Add at least 1 goal${suffix}`,
    },
    {
      key: 'features',
      label: 'Features (≥ 5)',
      done: features >= 5,
      hint: features >= 5 ? undefined : `Add ${Math.max(0, 5 - features)} more feature(s)${suffix}`,
    },
    {
      key: 'inScope',
      label: 'In scope (≥ 3)',
      done: inScope >= 3,
      hint: inScope >= 3 ? undefined : `Add ${Math.max(0, 3 - inScope)} more in-scope item(s)${suffix}`,
    },
  ];
}
